require('angular').module('wowApp.shop')
    .service('TrolleyService', ['$rootScope', 'Restangular', '$q', 'LoginService', 'ShopperService', 'RRPubSub', 'AtmService', 'DecorateAdditionalDetails', '$log', '$state', '$stateParams', 'BwsNotificationService', '$timeout', 'InMemoryStorage', 'AnonymousUserIdService', 'BreakpointsService', 'SearchService', 'SettingsService', require('./trolley-service')])
    .directive('wowTrolleyControls', ['TrolleyService', '$rootScope', 'AtmService', 'BwsNotificationService', '$stateParams', 'ShopperService', 'DecorateAdditionalDetails', 'CollectionTimeService', '$uibModal', 'StorePickerService', '$location', 'ShopLocatorService', require('./trolleycontrols-directive')])
    .constant('TrolleySource', require('./trolley-source'));



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/trolley/index.js
 **/